var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31_0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B3D6F0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M435.2,440.9h-0.2V16.4c0-9.1-7.4-16.4-16.4-16.4H93.3c-9.1,0-16.4,7.4-16.4,16.4v424.5h-52l-0.3,0v0h-0.2 v70.7v0.2l0,0v0.2h463.2v-71.1H435.2z M380,166.7h-41.3V86.4H380V166.7z M380,279.6h-41.3v-80.4H380V279.6z M338.7,357.3V324H380 v33.3H338.7L338.7,357.3z M290.4,86.4v80.4h-68.8h-0.1V86.4H290.4L290.4,86.4z M221.6,279.6v-80.4h68.9v80.4H221.6L221.6,279.6z  M290.4,324v144.4h-68.9V324H290.4z M132,357.3V324h41.3v33.3H132L132,357.3z M173.3,279.6H132v-80.4h41.3V279.6L173.3,279.6z  M173.3,166.7H132V86.4h41.3V166.7L173.3,166.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.afeae0e10420ebe2b2b17043324152a8.svg";
export { ForwardRef as ReactComponent };